/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum CallidusBvsSelbstbehaltKunde {
    Sb500 = 'Sb500',
    Sb1000 = 'Sb1000',
    Sb2500 = 'Sb2500',
    Sb5000 = 'Sb5000',
    Sb7500 = 'Sb7500',
    Sb10000 = 'Sb10000',
    Sb15000 = 'Sb15000'
  }

    export const CallidusBvsSelbstbehaltKundeTranslocoMap: Record<CallidusBvsSelbstbehaltKunde, string> = {
    [CallidusBvsSelbstbehaltKunde.Sb500]: 'callidusBvsSelbstbehaltKunde.sb500',
    [CallidusBvsSelbstbehaltKunde.Sb1000]: 'callidusBvsSelbstbehaltKunde.sb1000',
    [CallidusBvsSelbstbehaltKunde.Sb2500]: 'callidusBvsSelbstbehaltKunde.sb2500',
    [CallidusBvsSelbstbehaltKunde.Sb5000]: 'callidusBvsSelbstbehaltKunde.sb5000',
    [CallidusBvsSelbstbehaltKunde.Sb7500]: 'callidusBvsSelbstbehaltKunde.sb7500',
    [CallidusBvsSelbstbehaltKunde.Sb10000]: 'callidusBvsSelbstbehaltKunde.sb10000',
    [CallidusBvsSelbstbehaltKunde.Sb15000]: 'callidusBvsSelbstbehaltKunde.sb15000',
    };

    export const CallidusBvsSelbstbehaltKundeOptions = [
  { value: CallidusBvsSelbstbehaltKunde.Sb500, labelKey: 'callidusBvsSelbstbehaltKunde.sb500' },
  { value: CallidusBvsSelbstbehaltKunde.Sb1000, labelKey: 'callidusBvsSelbstbehaltKunde.sb1000' },
  { value: CallidusBvsSelbstbehaltKunde.Sb2500, labelKey: 'callidusBvsSelbstbehaltKunde.sb2500' },
  { value: CallidusBvsSelbstbehaltKunde.Sb5000, labelKey: 'callidusBvsSelbstbehaltKunde.sb5000' },
  { value: CallidusBvsSelbstbehaltKunde.Sb7500, labelKey: 'callidusBvsSelbstbehaltKunde.sb7500' },
  { value: CallidusBvsSelbstbehaltKunde.Sb10000, labelKey: 'callidusBvsSelbstbehaltKunde.sb10000' },
  { value: CallidusBvsSelbstbehaltKunde.Sb15000, labelKey: 'callidusBvsSelbstbehaltKunde.sb15000' },
    ];

